// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1rfKA","content":"styles_content__eyDmC","selectAll":"styles_selectAll__1ZuOj"};